var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSocialIconsYoutube(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.84 5.432s-.156-1.103-.637-1.587c-.61-.638-1.29-.64-1.603-.678-2.237-.163-5.597-.163-5.597-.163h-.006s-3.36 0-5.597.163c-.313.037-.994.04-1.603.678-.481.484-.635 1.587-.635 1.587S0 6.73 0 8.022v1.213c0 1.294.16 2.591.16 2.591s.156 1.103.634 1.588c.61.637 1.41.615 1.765.684 1.282.122 5.441.16 5.441.16s3.363-.007 5.6-.166c.313-.038.994-.041 1.603-.678.481-.485.638-1.588.638-1.588S16 10.532 16 9.236V8.022c0-1.294-.16-2.59-.16-2.59Zm-9.493 5.275V6.21l4.322 2.257-4.322 2.24Z",
    fill: "#FCFCFD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIconsYoutube);
export default __webpack_public_path__ + "static/media/socialIcons - Youtube.42f48706d1f50bc34c12b37173aea6a3.svg";
export { ForwardRef as ReactComponent };